<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['view_loanapplications'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <span class="d-flex justify-content-between mb-2">

            </span>
            <div class="clearfix"></div>
            <div class="text-end mb-1"><button class="btn btn-sm btn-primary fw-bold"
                @click="$router.push('/credit-score')"><i class="mdi mdi-plus"></i> New Credit Report</button></div>
            <div class="row">
              <div class="col-sm-12 col-md-3">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm"
                      :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-4">
                <div class="row">
                  <div class="col-6">
                    <select v-model="report_type" class="form-select">
                      <option value="1">All Reports</option>
                      <option value="2">Hidden</option>
                    </select>
                  </div>
                  <div class="col-6">
                    <select v-model="remarks" class="form-select">
                      <option value="0">All</option>
                      <option value="1">Excellent</option>
                      <option value="2">Very Good</option>
                      <option value="3">Good</option>
                      <option value="4">Fair</option>
                      <option value="5">Low</option>
                      <option value="6">Poor</option>
                    </select>
                  </div>
                </div>

              </div>
              <div class="col-sm-12 col-md-5">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table :items="Items" :fields="Fields" responsive="sm" :per-page="perPage" :current-page="currentPage"
                :filter="filter" :filter-included-fields="filterOn" @filtered="Filtered" :busy="IsBusy">
                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner v-if="isBusy" class="align-middle" type="grow" small></b-spinner>
                    <i v-else class="fs-5 mdi mdi-cancel"></i>
                    <strong>{{ isBusy ? 'Fetching Data...' : 'No Data Found' }}</strong>
                  </div>
                </template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(member)="data">
                  <router-link :to="{
                    path: '/memberprofile',
                    query: { id: data.item.member.member_id },
                  }">
                    <span @mouseover="name_hover = true; current_index = data.index" @mouseout="name_hover = false">
                      <span
                        :class="(name_hover && current_index == data.index) ? 'fw-bold text-dark text-decoration-underline' : 'text-dark'">{{
                          data.item.member.name }}</span>
                      <span class="d-block text-info fw-bold">{{ data.item.member.member_id
                      }}</span>
                    </span>
                  </router-link>
                </template>

                <template #cell(credit_score)="data">
                  <span class="">{{ scaleValue(data.item) }} points</span>
                  <small class="d-block fw-bold text-info">{{ creditScoreTotal(data.item) }}%</small>
                </template>

                <template #cell(remarks)="data">
                  <span v-if="scaleValue(data.item) >= 744 && scaleValue(data.item) <= 850"
                    :style="{ backgroundColor: '#108c59' }" class="badge">Excellent</span>
                  <span v-else-if="scaleValue(data.item) >= 718 && scaleValue(data.item) <= 743"
                    :style="{ backgroundColor: '#5ea744' }" class="badge">Very Good</span>
                  <span v-else-if="scaleValue(data.item) >= 697 && scaleValue(data.item) <= 717"
                    :style="{ backgroundColor: '#b4b436' }" class="badge">Good</span>
                  <span v-else-if="scaleValue(data.item) >= 651 && scaleValue(data.item) <= 696"
                    :style="{ backgroundColor: '#e6c61d' }" class="badge">Fair</span>
                  <span v-else-if="scaleValue(data.item) >= 529 && scaleValue(data.item) <= 650"
                    :style="{ backgroundColor: '#ee7726' }" class="badge">Low</span>
                  <span v-else :style="{ backgroundColor: '#d62328' }" class="badge">Poor</span>
                </template>

                <template #cell(recommendation)="data">
                  <span class="fw-bold fs-5 mb-0">{{ commas(data.item.saving_balance * loanLimit *
                    creditPercentage(data.item)) }}/=</span>
                  <small class="d-block fw-bold text-info">{{ loanLimit * 100 * creditPercentage(data.item) }}% of their
                    Savings</small>
                </template>

                <template #cell(actions)="data">
                  <button @click.prevent="viewDetails(data.item)" v-if="report_type == 1" class="btn btn-sm btn-primary"
                    title="View Details"><i class="mdi mdi-clipboard-text"></i></button>
                  <button
                    @click.prevent="restore(data.item.id, data.item.member.member_id, data.item.member.name, data.item.created_at)"
                    v-if="report_type == 2" class="btn btn-sm btn-dark" title="Restore"><i
                      class="mdi mdi-eye-outline"></i></button>
                  <button
                    @click.prevent="hide(data.item.id, data.item.member.member_id, data.item.member.name, data.item.created_at)"
                    v-if="report_type == 1" class="btn btn-sm btn-dark" title="Remove from View"><i
                      class="mdi mdi-eye-off-outline"></i></button>
                  <button
                    @click.prevent="deleteModal(data.item.id, data.item.member.member_id, data.item.member.name, data.item.created_at)"
                    v-if="report_type == 2" class="btn btn-sm btn-danger" title="Delete Report"><i
                      class="mdi mdi-trash-can"></i></button>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to Credit Score Reports</span></center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="details" hide-header hide-footer size="lg">
      <div class="row">
        <div class="col-9 text-primary fs-5">Credit Report for Member - {{ member.member_id }} | {{ member.name }}</div>
        <div class="col text-primary fs-5"><i>Date: {{ report_date }}</i></div>
      </div>
      <hr>
      <div class="row">
        <div class="col-6 pe-5">
          <center style="position: relative;">
            <h3 class="mb-2">Credit Score Meter</h3>
            <VueSpeedMeter :customCurrentValue="scaledCreditScore" :customStyle="{
              size: 350,
              mainBackgroundColor: '#FAF9F6',
              borderColor: '#130F0B',
              scaleColor: scaleColor,
              scaleValuesColor: scaleColor,
              scaleStartValue: 299,
              scaleStep: 46,
              needleColor: '#3F4140',
              needleCircleColor: scaleColor,
              needleCircleBorderColor: '#545454'
            }" :needleAnimation="true" :shadowFilter="false" />
            <div class="h2 text-center mb-0 ms-3" style="position: relative; margin-top: -80px;"
              :style="{ color: scaleColor }">
              {{ scaledCreditScore }}
            </div>
            <div class="ms-3" style="position: relative; margin-top: -5px;">
              {{ comment }}
            </div>
          </center>
          <br><br>
          <div class="score-key">
            <hr>
            <h3>Credit Score Interpretation</h3>
            <ul class="fw-bold ms-2">
              <li style="color: #d62328">300 - 528: Poor</li>
              <li style="color: #ee7726 ">529 - 650: Low</li>
              <li style="color: #e6c61d">651 - 696: Fair</li>
              <li style="color: #b4b436">697 - 717: Good</li>
              <li style="color: #5ea744">718 - 743: Very Good</li>
              <li style="color: #108c59">744 - 850: Excellent</li>
            </ul>
          </div>

        </div>
        <div class="col">
          <!-- Breakdown of the credit score -->
          <div class="score-details">
            <h3>Score Breakdown</h3>
            <ul>
              <li v-for="(param, index) in parameters" :key="index" class="row">
                <strong>{{ param.name }}:</strong>
                <div class="col-3">{{ param.value }} points
                </div>
                <div class="col text-primary"> <span> (Max: {{ param.maxPoints }} points)</span>
                </div>
              </li>
            </ul>
          </div>

          <!-- Total score -->
          <div class="total-score">
            <h5 class="text-primary">Total Points: {{ totalPoints }} / 100</h5>
          </div>

          <!-- Recommendations -->
          <br><br>
          <h3>Recommendations</h3>
          <p class="mb-0">The member's loan limit should be set at:</p>
          <div style="margin-top: -5px" class="align-items-center">
            <div class="fs-2 pb-0 mb-0 fw-bold text-primary"> {{ commas(loanLimit * saving_balance * creditPercentage({
              loan_repayment: parameters[0].value,
              saving_history: parameters[1].value,
              character: parameters[2].value,
              repayment_capacity: parameters[3].value,
              membership: parameters[4].value,
              meeting_attendance: parameters[5].value,
              purpose: parameters[6].value,
              bank_statements: parameters[7].value
            })) }}/=</div>
            <div style="margin-top: -7px" class="fs-5 text-primary">{{ loanLimit * 100 * creditPercentage({
              loan_repayment: parameters[0].value,
              saving_history: parameters[1].value,
              character: parameters[2].value,
              repayment_capacity: parameters[3].value,
              membership: parameters[4].value,
              meeting_attendance: parameters[5].value,
              purpose: parameters[6].value,
              bank_statements: parameters[7].value
            }) }}% of their Savings</div>
          </div>
          <div class="text-end mt-3">
            <button v-if="backToLoanApplication" @click="goToLoanApplication" class="btn btn-secondary me-2">Back to
              Application</button>
            <button v-else @click="$bvModal.hide('details')" class="btn btn-secondary me-2">Close</button>
            <button @click="printReport" class="btn btn-outline-primary">Print</button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal id="hide-confirm" centered hide-header hide-footer>
      <div class="text-center">
        <div><i class="fs-1 mdi mdi-eye-off"></i></div>
        <p>Are you sure you want to hide <strong>Report-{{ report_date }}</strong> for</p>
        <p><strong>{{ member.member_id }} | {{ member.name }}</strong></p>
        <b-button class="mx-1" variant="dark" @click="hideReport">
          <b-spinner v-if="modal_loader" small></b-spinner>
          <span v-else>Yes, Hide</span>
        </b-button>
        <b-button variant="secondary" @click="$bvModal.hide('hide-confirm')">Cancel</b-button>
      </div>
    </b-modal>

    <b-modal id="delete-confirm" centered hide-header hide-footer>
      <div class="text-center">
        <div><i class="fs-1 mdi mdi-trash-can text-danger"></i></div>
        <p>Are you sure you want to permanently delete <strong>Report-{{ report_date }}</strong> for</p>
        <p><strong>{{ member.member_id }} | {{ member.name }}</strong></p>
        <b-button class="mx-1" variant="danger" @click="deleteReport">
          <b-spinner v-if="modal_loader" small></b-spinner>
          <span v-else>Yes, Delete</span>
        </b-button>
        <b-button variant="secondary" @click="$bvModal.hide('delete-confirm')">Cancel</b-button>
      </div>
    </b-modal>

    <b-modal id="restore-confirm" centered hide-header hide-footer>
      <div class="text-center">
        <div><i class="fs-1 mdi mdi-eye"></i></div>
        <p>Are you sure you want to restore <strong>Report-{{ report_date }}</strong> for</p>
        <p><strong>{{ member.member_id }} | {{ member.name }}</strong></p>
        <b-button class="mx-1" variant="dark" @click="restoreReport">
          <b-spinner v-if="modal_loader" small></b-spinner>
          <span v-else>Yes, Restore</span>
        </b-button>
        <b-button variant="secondary" @click="$bvModal.hide('restore-confirm')">Cancel</b-button>
      </div>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import VueSpeedMeter from "vue-speed-meter";

import { creditReportComputed, creditReportMethods } from "@/state/helpers";

export default {
  page: {
    title: "Credit Score Reports",
    meta: [{ name: "description", content: appConfig.description, },],
  },
  components: {
    Layout, PageHeader, VueSpeedMeter
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Credit Score Reports",
      items: [{ text: "Dashboard", to: "/", }, { text: "Credit Score Reports", active: true, },],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: 'index', label: '#', visible: true },
        { key: 'id', label: 'ID', visible: false },
        { key: 'member', label: 'Name', visible: true },
        { key: 'credit_score', label: 'Credit Score', visible: true },
        { key: 'remarks', label: 'Remarks', visible: true },
        { key: 'recommendation', label: 'Recommended Loan Limit', visible: true },
        { key: 'created_at', label: 'Generated on', visible: true },
        { key: 'addedby', label: 'Generated by', visible: true },
        { key: 'actions', label: 'Actions', visible: true },
      ],
      modal_loader: false,
      id: '',
      member: '',
      loanLimit: JSON.parse(localStorage.getItem('user')).settings.loanlimit,
      report_type: 1,
      scaledCreditScore: 300,
      comment: 'Poor',
      percentage: 0,
      report_date: '',
      parameters: [
        { name: 'Loan Repayment History', value: 0, maxPoints: 35 },
        { name: 'Saving History', value: 0, maxPoints: 15 },
        { name: 'Character Assessment', value: 0, maxPoints: 15 },
        { name: 'Capacity to Repay', value: 0, maxPoints: 15 },
        { name: 'Duration of Membership', value: 0, maxPoints: 5 },
        { name: 'Meeting Attendance', value: 0, maxPoints: 5 },
        { name: 'Purpose of Loan', value: 0, maxPoints: 5 },
        { name: 'Availability of Bank Statements', value: 0, maxPoints: 5 }
      ],

      currentdate: new Date().toLocaleDateString('fr-CA'),
      date_to: new Date().toLocaleDateString('fr-CA'),
      date_from: new Date().toLocaleDateString('fr-CA'),
      name_hover: false,
      current_index: null,
      backToLoanApplication: false,
      remarks: 0,
      saving_balance: 0,
    };
  },
  computed: {
    ...creditReportComputed,
    List() { return this.creditreports.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() {
      return this.creditreports
        .filter(d => d.status == this.report_type)
        .filter(d => {
          if (this.remarks == 0) {
            return d;
          } else if (this.remarks == 1) {
            return this.scaleValue(d) >= 744 && this.scaleValue(d) <= 850;
          } else if (this.remarks == 2) {
            return this.scaleValue(d) >= 718 && this.scaleValue(d) <= 743;
          } else if (this.remarks == 3) {
            return this.scaleValue(d) >= 697 && this.scaleValue(d) <= 717;
          } else if (this.remarks == 4) {
            return this.scaleValue(d) >= 651 && this.scaleValue(d) <= 696;
          } else if (this.remarks == 5) {
            return this.scaleValue(d) >= 529 && this.scaleValue(d) <= 650;
          } else if (this.remarks == 6) {
            return this.scaleValue(d) >= 300 && this.scaleValue(d) <= 528;
          }
        })
        .map(d => ({ ...d }));
    },
    IsBusy() { let a = false; if (this.Items.length > 0) { a = false; } else { a = true; } return a },
    totalPoints() {
      return this.parameters.reduce((acc, param) => acc + param.value, 0);
    },
    scaleColor() {
      let color = '';
      if (this.scaledCreditScore >= 300 && this.scaledCreditScore <= 528) {
        color = '#d62328';
      } else if (this.scaledCreditScore >= 529 && this.scaledCreditScore <= 650) {
        color = '#ee7726';
      } else if (this.scaledCreditScore >= 651 && this.scaledCreditScore <= 696) {
        color = '#e6c61d';
      } else if (this.scaledCreditScore >= 697 && this.scaledCreditScore <= 717) {
        color = '#b4b436';
      } else if (this.scaledCreditScore >= 718 && this.scaledCreditScore <= 743) {
        color = '#5ea744';
      } else if (this.scaledCreditScore >= 744 && this.scaledCreditScore <= 850) {
        color = '#108c59';
      }
      return color
    },
  },
  async mounted() {
    if (this.$route.params.credit_report) {
      this.backToLoanApplication = true
      this.modal_loader = true
      this.$bvModal.show('details')
      await axios.get('credit-score-report/' + this.$route.params.credit_report)
        .then((response) => {
          this.viewDetails(response.data.report)
          this.modal_loader = false
        })
    }
    await this.fetchCreditReports();
    this.TotalRows = this.creditreports.length;
    this.isBusy = false;
  },
  methods: {
    ...creditReportMethods,
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    creditScoreTotal(data) {
      return data.loan_repayment + data.saving_history + data.character + data.repayment_capacity + data.membership + data.meeting_attendance + data.purpose + data.bank_statements;
    },

    scaleValue(data) {
      let clampedTotal = Math.min(Math.max(this.creditScoreTotal(data), 0), 100);
      let scaledValue = 300 + ((clampedTotal - 0) * (850 - 300)) / (100 - 0);

      return Math.floor(scaledValue);
    },

    creditPercentage(data) {
      let percentage = 0;
      if (this.scaleValue(data) >= 300 && this.scaleValue(data) <= 528) {
        percentage = 0.3;
      } else if (this.scaleValue(data) >= 529 && this.scaleValue(data) <= 650) {
        percentage = 0.5;
      } else if (this.scaleValue(data) >= 651 && this.scaleValue(data) <= 696) {
        percentage = 0.7;
      } else if (this.scaleValue(data) >= 697 && this.scaleValue(data) <= 717) {
        percentage = 0.9;
      } else if (this.scaleValue(data) >= 718 && this.scaleValue(data) <= 743) {
        percentage = 1.0;
      } else if (this.scaleValue(data) >= 744 && this.scaleValue(data) <= 850) {
        percentage = 1.2;
      }
      return percentage
    },

    setComment() {
      if (this.scaledCreditScore >= 300 && this.scaledCreditScore <= 528) {
        this.comment = "Poor";
      } else if (this.scaledCreditScore >= 529 && this.scaledCreditScore <= 650) {
        this.comment = "Low";
      } else if (this.scaledCreditScore >= 651 && this.scaledCreditScore <= 696) {
        this.comment = "Fair";
      } else if (this.scaledCreditScore >= 697 && this.scaledCreditScore <= 717) {
        this.comment = "Good";
      } else if (this.scaledCreditScore >= 718 && this.scaledCreditScore <= 743) {
        this.comment = "Very Good";
      } else if (this.scaledCreditScore >= 744 && this.scaledCreditScore <= 850) {
        this.comment = "Excellent";
      }
    },

    clearFields() {
      this.id = ''
      this.member = ''
      this.report_date = ''
    },

    hide(id, member_id, name, date) {
      this.id = id
      this.member = {
        member_id: member_id,
        name: name
      }
      this.report_date = date
      this.$bvModal.show('hide-confirm');
    },

    deleteModal(id, member_id, name, date) {
      this.id = id
      this.member = {
        member_id: member_id,
        name: name
      }
      this.report_date = date
      this.$bvModal.show('delete-confirm');
    },

    restore(id, member_id, name, date) {
      this.id = id
      this.member = {
        member_id: member_id,
        name: name
      }
      this.report_date = date
      this.$bvModal.show('restore-confirm');
    },

    viewDetails(data) {
      this.$bvModal.show('details');
      this.member = data.member;
      this.saving_balance = data.saving_balance;
      this.parameters[0].value = data.loan_repayment;
      this.parameters[1].value = data.saving_history;
      this.parameters[2].value = data.character;
      this.parameters[3].value = data.repayment_capacity;
      this.parameters[4].value = data.membership;
      this.parameters[5].value = data.meeting_attendance;
      this.parameters[6].value = data.purpose;
      this.parameters[7].value = data.bank_statements;
      this.scaledCreditScore = this.scaleValue(data);
      this.report_date = data.created_at;
      this.setComment();
      this.creditPercentage(data);
    },

    async hideReport() {
      this.modal_loader = true;
      const obj = {
        id: this.id,
      }
      await axios.post('hide-credit-report', obj)
        .then(() => {
          this.modal_loader = false;
          this.$bvModal.hide('hide-confirm');
          this.$toast.error('Report removed from view')
          this.fetchCreditReports();
          this.clearFields()
        })
        .catch(() => {
          this.modal_loader = false;
          this.$bvModal.hide('hide-confirm');
        })
    },

    async restoreReport() {
      this.modal_loader = true;
      const obj = {
        id: this.id,
      }
      await axios.post('restore-credit-report', obj)
        .then(() => {
          this.modal_loader = false;
          this.$bvModal.hide('restore-confirm');
          this.$toast.success('Report restored')
          this.fetchCreditReports();
          this.clearFields()
        })
        .catch(() => {
          this.modal_loader = false;
          this.$bvModal.hide('restore-confirm');
        })
    },

    async deleteReport() {
      this.modal_loader = true;
      const obj = {
        id: this.id
      }
      await axios.post('delete-credit-report', obj)
        .then(() => {
          this.modal_loader = false;
          this.$bvModal.hide('delete-confirm');
          this.$toast.error('Report deleted')
          this.fetchCreditReports();
          this.clearFields()
        })
        .catch(() => {
          this.modal_loader = false;
          this.$bvModal.hide('delete-confirm');
        })
    },

    printReport() {
      let parameters = {
        'Loan Repayment History': this.parameters[0].value,
        'Saving History': this.parameters[1].value,
        'Character Assessment': this.parameters[2].value,
        'Capacity to Repay': this.parameters[3].value,
        'Duration of Membership': this.parameters[4].value,
        'Meeting Attendance': this.parameters[5].value,
        'Purpose of Loan': this.parameters[6].value,
        'Availability of Bank Statements': this.parameters[7].value
      }
      this.$router.push({
        name: 'creditreport', params: {
          member: {
            member_id: this.member.member_id,
            name: this.member.name
          },
          comment: this.comment,
          saving_balance: this.saving_balance,
          parameters: parameters
        }
      })
    },

    goToLoanApplication() {
      this.$router.push({ name: 'loanapplication', params: { member: this.member } })
    }
  },
};
</script>